import api from '../../api'
import Swal from 'sweetalert2';
import store from "../../store";
const actions = {
    namespaced: true,
    state: () => ({
        row: null,
    }),
    mutations: {
        put( state, row) {
          
            console.log('ocultar_row', row.route);
            this.dispatch('actions/actionUpdate', row);
        },
        ocultar( state , row) {
            state.row = row;
            //state.route = row.route;
            Swal.fire({
                icon: 'question',
                title: `${row.title} de ${row.cliente.name} será deletado e todos os seus dados serão perdidos. Deseja continuar?`,
                showDenyButton: true,
                confirmButtonText: "Sim",
                denyButtonText: `Não`,
            }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    this.dispatch('actions/actionDelete', row);
                }
            });
        }
    },
    actions: {
        async actionUpdate(state, row) {
            await api.put(`${row.route}/${row.id}`);
            store.commit('datatable/setReload');
        },
        async actionDelete(state, row) {
            await api.delete(`${row.route}/${row.id}`);
            store.commit('datatable/setReload');
        }
    }, // promise axios

}


export default actions;